import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Upload, File, FileText, Loader2 } from 'lucide-react';

export function ClientDocumentsTab({ documents, uploading, getRootProps, getInputProps, isDragActive, formatDate }) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="font-heading text-lg flex items-center gap-2">
            <Upload className="w-5 h-5 text-primary" />
            Upload Documents
          </CardTitle>
          <CardDescription>Upload supporting documents for your case (PDF, images, Word docs - max 10MB)</CardDescription>
        </CardHeader>
        <CardContent>
          <div
            {...getRootProps()}
            className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors ${
              isDragActive ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/50'
            }`}
            data-testid="document-dropzone"
          >
            <input {...getInputProps()} />
            {uploading ? (
              <Loader2 className="w-8 h-8 mx-auto mb-2 animate-spin text-primary" />
            ) : (
              <Upload className="w-8 h-8 mx-auto mb-2 text-muted-foreground" />
            )}
            <p className="font-body text-sm text-muted-foreground">
              {isDragActive ? 'Drop files here...' : 'Drag & drop files here, or click to select'}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="font-heading text-lg flex items-center gap-2">
            <File className="w-5 h-5 text-primary" />
            Uploaded Documents ({documents.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          {documents.length === 0 ? (
            <p className="font-body text-sm text-muted-foreground text-center py-4">No documents uploaded yet</p>
          ) : (
            <div className="space-y-2">
              {documents.map((doc, idx) => (
                <div key={doc.id || idx} className="flex items-center justify-between p-3 bg-secondary/50 rounded-lg">
                  <div className="flex items-center gap-3">
                    <FileText className="w-5 h-5 text-primary" />
                    <div>
                      <p className="font-body text-sm font-medium">{doc.filename}</p>
                      <p className="font-body text-xs text-muted-foreground">
                        Uploaded {formatDate(doc.uploaded_at)} {doc.size ? `• ${(doc.size / 1024).toFixed(1)} KB` : ''}
                      </p>
                    </div>
                  </div>
                  {doc.source === 'client_portal' && (
                    <span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded">You uploaded</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
